import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { configuracion } from 'src/app/recursos/config.service';
import { ToolsService } from 'src/app/recursos/tools.service';
import { IngresoService } from 'src/app/servicios/ingreso.service';
import { LoaderComponent } from 'src/app/servicios/loader/loader.component';
import { SeleccionService } from 'src/app/servicios/seleccion.service';

@Component({
  selector: 'app-calificaciones25',
  templateUrl: './calificaciones25.component.html',
  styleUrls: ['./calificaciones25.component.css']
})
export class Calificaciones25Component implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecFacultad = []; public vecCarrera = []; public vecPeriodo = []; public vecParametro = [];
  public vecEstudiante = []; vecAltoRendimiento = []; vecAuxAltoRendimiento = []; public encabezado: string = ''; public vecAjustes = [];
  public selectPeriodo: string = ''; private fechaHoy: string = ''; public vecPostula = [];


  public postProvincia = ''; public postCiudad = ''; public postSexo = ''; public postDiscapacidad = ''; public postPorcentaje = ''; public postDiversidad = ''; public postEtnia = '';
  public postNivel = 0; public postProm = 0; public postAsiste = 0; public postCupo = 0; public postIndice = 0;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.encabezado = "Estudiantes con mejores promedios";
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarPeriodosFacultad(); this.calculoFecha(); this.cargarParametros();
  }
  //FUNCION QUE CARGA LOS PARAMETROS ESTABLECIDOS PARA LAS BECAS
  async cargarParametros() {
    this.vecAjustes = [];
    const resAjuste = await new Promise<any>(resolve =>
      this.srvSelect.gestionOtros(2, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resAjuste.success) {
      this.vecAjustes = resAjuste.ajustes;
    }
  }
  //FUNCION PARA INSTANCIAR EL VECTOR DE PARAMETROS
  inicarParametro() {
    this.vecParametro = [];
    this.vecParametro.push({
      facultad: 0, codUnico: 0, periodo: this.selectPeriodo, homologa: 1
    })
  }
  //FUNCION QUE CARGA TODOS LOS PERIODOS ACADEMICOS Y CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarPeriodosFacultad() {
    this.vecPeriodo = []; this.vecFacultad = [];
    const resPeriodo = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPeriodo.success) {
      this.selectPeriodo = resPeriodo.carrera[1]['strCodigo'];
      this.vecPeriodo = resPeriodo.carrera;
    }
    //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION      
    const resFacultad = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resFacultad.success)
      this.vecFacultad = resFacultad.carrera;
  }
  //FUNCION QUE CARGA TODAS LAS CARRERAS DADA UNA FACULTAD DE LA INSTITUCION
  async cargarCarreras(facultad) {
    this.vecCarrera = [];
    const resCarrera = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(2, facultad, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCarrera.success)
      this.vecCarrera = resCarrera.carrera;
    this.vecParametro[0].codUnico = 0;
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE VER LOS PARAMETROS DEL REPORTE DE MEJORES ESTUDIANTES
  modalCriterioReporte(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.inicarParametro();
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }

  //OPCIONES PARA GENEARAR EL REPORTE
  async generaReporte() {
    this.vecAltoRendimiento = []; this.vecAuxAltoRendimiento = [];
    if (this.vecParametro[0].homologa == 2) {
      if (this.vecParametro[0]['facultad'] == '0')
        this.alerti.error('Debe seleccionar una facultad');
      else {
        if (this.vecParametro[0]['codUnico'] == '0')
          this.verReporteFacultad();
        else
          this.verReporteCarrera();
      }
    }
    else {
      this.cargando.abrir();
      await this.verAltoRendimientoHomola();
      this.dtTrigger.next();
      this.cerrarModal();
      this.cargando.cerrar();
    }
  }
  //GENERAR EL REPORTE POR LA FACULTAD
  async verReporteFacultad() {
    this.cerrarModal();

    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //GENERAR EL REPORTE POR CARRERA
  async verReporteCarrera() {
    this.cerrarModal();
    this.cargando.abrir();
    // this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'Reporte mejores estudiantes por carrera',
    //   'Imprimir el reporte de los estudiantes con mejor promedio reglamento 2024 para las becas de alto rendimiento', 1, 'Cod Carrera - ' + this.vecParametro[0]['codUnico'], 1).subscribe(res => {
    //   });
    //OBTENER TODAS LAS CARRERAS QUE PERTENECEN AL CODIGO UNICO SELECCIONADO
    const resCarreras = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(6, this.vecParametro[0]['codUnico'], 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCarreras.success) {
      for (let objCarrera of resCarreras.carrera) {
        const resMatr = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(18, objCarrera.baseCarrera, this.vecParametro[0]['periodo'],
          this.vecAjustes[3]['strValor'], 'na').subscribe(translated => { resolve(translated) }));
        if (resMatr.success) {
          for (let objAR of resMatr.matricula) {
            this.vecAltoRendimiento.push({ 'promedio': objAR, 'carrera': objCarrera });
          }
        }
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }

  obtenerMejoresNotas(objCarrera, objPromedio, numPromedio) {
    let vecBan = [];
    for (let objProm of objPromedio) {
      if (vecBan.filter(item => item.promedio == objProm.promedio).length == 0) {
        vecBan.push({ 'promedio': objProm.promedio })
      }
    }
    let dimPromedio = numPromedio <= vecBan.length ? numPromedio : vecBan.length;
    for (let cont = 0; cont < dimPromedio; cont++) {
      objPromedio.carrera = objCarrera
      for (let objBan of objPromedio.filter(item => item.promedio == vecBan[cont]['promedio']))
        this.vecAltoRendimiento.push({ 'promedio': objBan, 'carrera': objCarrera });
    }
  }
  //OBTENER EL REPORTE DE LOS ESTUDIANTES CON MEJORES PROMEDIOS QUE APLICAN A LA BECA DE ALTO RENDIMIENTO CON HOMOLOGACION
  async verAltoRendimientoHomola() {
    const resCarreras = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(6, this.vecParametro[0]['codUnico'], 'na', 'na').subscribe(translated => { resolve(translated) }));
    if (resCarreras.success) {
      for (let objCarrera of resCarreras.carrera) {
        //OBTENER LOS NIVELES Y PENSUM DADO EL PERÍODO
        const resNivel = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(21, objCarrera.baseCarrera, this.vecParametro[0]['periodo'], 'na', 'na').subscribe(translated => { resolve(translated) }));
        if (resNivel.success) {
          for (let objNivel of resNivel.matricula) {
            this.vecAuxAltoRendimiento = [];
            //OBTENER LAS MATERIAS OBLIGATORIAS E ITINERAIOS DADO EL NIVEL Y PENSUM
            const resMaterias = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(22, objCarrera.baseCarrera, objNivel.strCodNivel, objNivel.strCodPensum, 'na').subscribe(translated => { resolve(translated) }));
            if (resMaterias.success) {
              console.log("NIV..............: ", objNivel.strCodNivel, "NOR..............: ", resMaterias.matricula.filter((objMat: any) => objMat.strCodTipo == 'NOR').length,
                "ITI..............: ", resMaterias.matricula.filter((objMat: any) => objMat.strCodTipo == 'ITI').length);
              //OBTENER LOS ESTUDIANTES CON MATRICULA DEFINITIVA DADO EL NIVEL Y PERIODO
              const resMatricul = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(23, objCarrera.baseCarrera, objNivel.strCodPeriodo, objNivel.strCodNivel, 'na').subscribe(translated => { resolve(translated) }));
              if (resMatricul.success) {
                for (let objEst of resMatricul.matricula) {
                  const resRecord = await new Promise<any>(resolve => this.srvSelect.gestionMatriculaDosNotas(3, objCarrera.baseCarrera, objEst.strCodigo, 'na', 'na').subscribe(translated => { resolve(translated) }));
                  if (resRecord.success)
                    this.determinaARHomologa(resMaterias.matricula, resRecord.matricula, objEst, objCarrera,
                      resMaterias.matricula.filter((objMat: any) => objMat.strCodTipo == 'NOR').length, resMaterias.matricula.filter((objMat: any) => objMat.strCodTipo == 'ITI').length);
                }
              }
            }
            //ORDENAR LAS NOTAS DE MAYOR A MENOR
            this.ordenarVectorNotas(this.vecAuxAltoRendimiento);
          }
        }
      }
    }
  }
  determinaARHomologa(objMaterias, objRecord, objEstudiante, objCarrera, totalNor, totalIti) {
    let contNor = 0; let contIti = 0; let contCon = 0; let contHom = 0; let sumaNotas = 0; let banResta = 0;
    if ((objRecord.filter(item => item.Equivalencia == 'R').length == 0) && (objRecord.filter(item => item.Equivalencia == 'RVC').length == 0)) {
      for (let objMat of objMaterias) {

        let vecAprueba = objRecord.filter(objRec => ((objRec.CodigoMateriaAnterior == objMat.codMateria) || (objRec.CodigoMateriaNueva == objMat.codMateria)));
  
        if (vecAprueba.length > 0) {

          if (vecAprueba[0].Equivalencia == 'H') contHom++;
          if ((vecAprueba[0].Equivalencia == 'RC') || (vecAprueba[0].Equivalencia == 'AVC')) contCon++;

          if (vecAprueba[0].Suspension == null) {
            if (objMat.strCodTipo == "NOR")
              contNor++;
            if (objMat.strCodTipo == "ITI")
              contIti++; sumaNotas += vecAprueba[0].ComputoTotal;
          }
          else {
            if (vecAprueba[0].Suspension < 0) {
              if (objMat.strCodTipo == "NOR")
                contNor++;
              if (objMat.strCodTipo == "ITI")
                contIti++;
              sumaNotas += vecAprueba[0].ComputoTotal;
            }
            else
              banResta++;
          }
        }
      }
      //console.log('CARRERA: ', objCarrera.baseCarrera, '; CEDULA: ', objEstudiante.strCedula, '; COD ESTUDIANTE:', objEstudiante.strCodigo, '; SUMA NOTAS: ', sumaNotas, '; MAT NORMALES:', contNor, '; MATERIAS ITINERARIOS: ', contIti, '; PROMEDIO:', (sumaNotas / (contNor + contIti)), '; BAN RESTA: ', banResta)
      // if (contNor == totalNor) {
      let promEstudiante = {
        carrera: { nombreFacultad: objCarrera.nombreFacultad, nombreCarrera: objCarrera.nombreCarrera },
        promedio: {
          estCedula: objEstudiante.strCedula, estNombres: objEstudiante.strNombres, estApellidos: objEstudiante.strApellidos,
          matNivel: objEstudiante.strCodNivel, totalNor: totalNor, asistencia: ((contNor * 100) / totalNor).toFixed(0),
          totalIti: totalIti, totalMateriasPen: (contNor + contIti) + ' / ' + ((contNor * 100) / totalNor).toFixed(2) + '%', totalConvalida: contCon + ' / ' + contHom,
          promedio: sumaNotas > 0 ? (sumaNotas / (contNor + contIti)).toFixed(3) : 0
        }
      };
      if (banResta == 0 && sumaNotas > 0) {
        if (totalIti == 0)
          this.vecAuxAltoRendimiento.push(promEstudiante)
        else
          if (contIti > 0)
            this.vecAuxAltoRendimiento.push(promEstudiante)
      }
    }
    // }
  }
  ordenarVectorNotas(objPromedio) {
    let cont = 0; let banTotal = 0; let vecAuxPromedio = []; let objAuxPromedio;
    objPromedio.sort((a, b) => (a.promedio.promedio > b.promedio.promedio) ? -1 : ((b.promedio.promedio > a.promedio.promedio) ? 1 : 0));

    for (let objPro of objPromedio) {
      if (cont == 0)
        vecAuxPromedio.push(objPro);
      if (cont > 0) {
        if (objPromedio[cont - 1].promedio.promedio > objPromedio[cont].promedio.promedio)
          banTotal++;
        if (banTotal <= 4)
          vecAuxPromedio.push(objPro);
      }
      cont++;
    }
    let con1 = 0; let con2 = 0;
    while (con1 < vecAuxPromedio.length) {
      con2 = 0;
      while (con2 < vecAuxPromedio.length) {
        if (parseFloat(vecAuxPromedio[con1].promedio.asistencia) > parseFloat(vecAuxPromedio[con2].promedio.asistencia)) {
          objAuxPromedio = vecAuxPromedio[con1];
          vecAuxPromedio[con1] = vecAuxPromedio[con2];
          vecAuxPromedio[con2] = objAuxPromedio;
        }
        con2++;
      }
      con1++;
    }

    for (let objAux of vecAuxPromedio)
      this.vecAltoRendimiento.push(objAux);
  }

  //FUNCION PARA ABRIR EL MODAL QUE MUESTRA DATOS DE UN POSTULANTE
  async modalModPostulantes(nameMod, objRol) {
    this.vecPostula = [];
    if (localStorage.getItem('modUser') == 'true') {
      this.inicarParametro();
      this.mr = this.modalService.open(nameMod);

      //CARGAMOS LOS DATOS NECESARIOS PARA ASIGNAR LA BECA AL ESTUDIANTES
      this.vecPostula.push({
        codEstudiante: objRol['codEstudiante'], fecha: this.fechaHoy, idBeca: localStorage.getItem('modBeca'), estado: 3, cedula: objRol['codigo'],
        resolucion: 'PENDIENTE', periodo: this.vecPeriodo[this.postIndice > 0 ? this.postIndice - 1 : this.postIndice]['codigo'], carrera: objRol['codCarrera'],
        facultad: objRol['codFacultad'], nivel: objRol['nivel']
      });
      this.postSexo = objRol['sexo'] == 'MAS' ? 'Hombre' : 'Mujer';
      this.postNivel = objRol['nivel']; this.postProm = objRol['nota'];
      this.postAsiste = objRol['asiste']; this.postCupo = 0;

      const resCodUnico = await new Promise<any>(resolve =>
        this.srvSelect.gestionCarreras(5, objRol['codCarrera'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resCodUnico.success) {
        const resCarreras = await new Promise<any>(resolve =>
          this.srvSelect.gestionCarreras(6, resCodUnico.carrera[0]['carrera_unica'], 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resCarreras.success) {
          for (let j in resCarreras.carrera) {
            const resAplica = await new Promise<any>(resolve =>
              this.srvSelect.gestionPostulantes(8, this.vecPeriodo[this.postIndice > 0 ? this.postIndice - 1 : this.postIndice]['codigo'],
                resCarreras.carrera[j]['codigoCarrera'], objRol['nivel'], localStorage.getItem('modBeca')).subscribe(translated => {
                  resolve(translated)
                }));
            if (resAplica.success) {
              this.postCupo = this.postCupo + resAplica.postula[0]['totalPostula'];
            }
          }
        }
        this.postCupo = this.vecAjustes[2]['strValor'] - this.postCupo;
      }

      const resProcede = await new Promise<any>(resolve =>
        this.srvSelect.gestionDatosPersonaMaster(1, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resProcede.success) {
        this.postCiudad = resProcede.persona[0]['nombCiudad'];
        this.postProvincia = resProcede.persona[0]['nombProvincia'];
      } else {
        this.postCiudad = 'No registra'; this.postProvincia = 'No registra';
      }

      const resDiscapacidad = await new Promise<any>(resolve =>
        this.srvSelect.gestionGruposCentral(13, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resDiscapacidad.success) {
        this.postDiscapacidad = resDiscapacidad.consulta[0]['detalle'];
        this.postPorcentaje = resDiscapacidad.consulta[0]['porcentaje'];
      } else {
        this.postDiscapacidad = 'No registra'; this.postPorcentaje = 'No registra';
      }

      const resDiversidad = await new Promise<any>(resolve =>
        this.srvSelect.gestionGruposCentral(14, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resDiversidad.success) {
        this.postDiversidad = resDiversidad.consulta[0]['detalle'];
      } else {
        this.postDiversidad = 'No registra';
      }

      const resEtnia = await new Promise<any>(resolve =>
        this.srvSelect.gestionGruposCentral(12, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resEtnia.success) {
        this.postEtnia = resEtnia.consulta[0]['detalle'];
      } else {
        this.postEtnia = 'No registra';
      }
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE ASIGNA UNA BECA DE ALTO RENDIMIENTO AL ESTUDIANTE SELECCIONADO
  async asignaBeca() {
    if (this.postCupo > 0) {
      const resPostula = await new Promise<any>(resolve =>
        this.srvSelect.gestionPostulantes(7, this.vecPostula[0]['codEstudiante'], this.vecPostula[0]['periodo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resPostula.success)
        this.alerti.error('El estudiante seleccionado ya tiene una postulación para el período actual')
      else {
        this.alerti.confirm('Está seguro de asignar la beca al estudiante seleccionado?', () => {
          this.aceptaTerminos();
        });
      }
    }
    else
      this.alerti.error('Ya no se admite más postulantes para la carrera y nivel seleccionado');
  }
  //ASIGNA LA BECA AL ESTUDIANTE SELECCIONADO
  aceptaTerminos() {
    this.srvInsert.ingresoGestionBecas(this.vecPostula[0]['codEstudiante'], this.vecPostula[0]['fecha'], this.vecPostula[0]['idBeca'], this.vecPostula[0]['estado'],
      this.vecPostula[0]['resolucion'], this.vecPostula[0]['periodo'], this.vecPostula[0]['codUnico'], this.vecPostula[0]['facultad'], this.vecPostula[0]['nivel'],
      'na', 'na', 'na', 'na', 'na', 12).subscribe(res => {
        if (res['becas'] == 'true') {
          this.srvSelect.personaCentralDocumento(this.vecPostula[0]['cedula'].replace('-', '')).subscribe(data => {
            if (data.success) {
              this.enviarCorreo(data.datos['per_nombres'] + " " + data.datos['per_primerApellido'] + " " + data.datos['per_segundoApellido'], data.datos['per_email']);//mi correo
              this.alerti.success('Beca asignada con éxito');
            }
          });
          this.cerrarModal();
        }
        else
          this.alerti.error("No se puede agregar la postulación. Intente más tarde.");
      });
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo(nombres, correo) {
    let contenido = this.confMensaje.bodyMensaje(1, 'na', 'na', 'na', 'na', 'na') + nombres + this.confMensaje.bodyMensaje(7, 'na', 'na', 'na', 'na', 'na');
    this.srvInsert.envioMail('Postulación Alto Rendimiento académico', correo, btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.correo)
        this.alerti.error("Error al enviar el correo electrónico");
    });
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
  //FUNCION QUE CALCULA LA FECHA ACTUAL DEL SISTEMA
  calculoFecha() {
    var hoy = new Date();
    var diahoy = hoy.getDate() < 10 ? "0" + hoy.getDate() : hoy.getDate();
    var meshoy = (hoy.getMonth() + 1) < 10 ? "0" + (hoy.getMonth() + 1) : (hoy.getMonth() + 1);
    var aniohoy = hoy.getFullYear();
    this.fechaHoy = aniohoy + "-" + meshoy + "-" + diahoy;
  }
}
